import React from "react";
import { useSelector } from "react-redux";
import { StepChangeAnalyticsEvents } from "@qgiv/core-donor";
import {
    getDataLayerOptions,
    sendStepChangeAnalyticsEvents,
} from "@qgiv/p2p-registration";
import { selectAllFormSettings } from "../../redux/slices/formSettingsSlice";
import { selectAllRegistration } from "../../redux/slices/registrationSlice";
import { selectReceipt } from "../../redux/slices/receiptSlice";
import { selectAppSettings } from "../../redux/slices/appSettingsSlice";
import { selectCurrentPage } from "../../redux/slices/currentPageSlice";

const ConnectedStepChangeAnalyticsEvents = () => {
    const appSettings = useSelector(selectAppSettings);
    const formSettings = useSelector(selectAllFormSettings);
    const registration = useSelector(selectAllRegistration);
    const currentPage = useSelector(selectCurrentPage);
    const receipt = useSelector(selectReceipt);

    const {
        hasLoadedFirstRegistrationPage = false,
        hasSubmittedRegistration = false,
    } = appSettings;

    // Generate all of the data that can be sent with payload
    const dataLayerOptions = getDataLayerOptions({
        formSettings,
        receipt,
        registration,
    });

    const hasSentStartAnalyticsEvents = hasLoadedFirstRegistrationPage;
    const hasSubmittedForm = hasSubmittedRegistration;

    const stepChangeAnalyticsEventsProps = {
        currentPage,
        dataLayerOptions,
        hasSentStartAnalyticsEvents,
        hasSubmittedForm,
        sendStepChangeAnalyticsEvents,
    };
    return <StepChangeAnalyticsEvents {...stepChangeAnalyticsEventsProps} />;
};

export default ConnectedStepChangeAnalyticsEvents;
